export default __webpack_public_path__ + "assets/72a61b208ea99bf29ebe0e006acd947b.svg";